module.exports = __webpack_public_path__ + "static/img/21ok.b80ba760.webp";